import React from 'react';
import { injectIntl, defineMessages, IntlShape } from 'react-intl';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';

import { iconColors as colors } from '../../colors';
import { endMeeting } from '../../lib/actions/room';
import { logEvent, Event } from '../../lib/analytics';
import { RoomActionsContext } from '../../lib/contexts';
import EndMeetingDialog from '../EndMeetingDialog';
import { IconEsc } from '../IconSet';


const messages = defineMessages({
  endMeeting: { id: 'endMeetingMsg' },
});


const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({
    handleEndMeeting: () => endMeeting(),
  },
  dispatch
  );


type Props = {}

type PropsType = Props & { intl: IntlShape } & ReturnType<typeof mapDispatchToProps>

function EndMeetingButton(props: PropsType) {

  const l10n = props.intl.formatMessage;
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const roomActionsContext = React.useContext(RoomActionsContext);

  const endMeeting = (): void => {
    setDialogOpen(false);
    props.handleEndMeeting();
    logEvent(Event.END_MEETING, { 'from': roomActionsContext });
  };

  const openDialog = (): void => {
    setDialogOpen(!dialogOpen);
  };

  return (
    <div>
      <React.Fragment>
        <MenuItem onClick={openDialog}>
          <ListItemIcon>
            <IconEsc color={colors.attention} size={32} />
          </ListItemIcon>
          <ListItemText primary={l10n(messages.endMeeting)} />
        </MenuItem>
        <EndMeetingDialog
          open={dialogOpen}
          onConfirm={endMeeting}
          onCancel={openDialog}
        />
      </React.Fragment>
    </div>
  );
}

export default connect(null, mapDispatchToProps)(injectIntl(EndMeetingButton));
